import { render, staticRenderFns } from "./Imepg.vue?vue&type=template&id=41e0e87a&scoped=true"
import script from "./Imepg.vue?vue&type=script&lang=js"
export * from "./Imepg.vue?vue&type=script&lang=js"
import style0 from "./Imepg.vue?vue&type=style&index=0&id=41e0e87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e0e87a",
  null
  
)

export default component.exports